import { ref } from '@vue/composition-api'

import useRequest from '@/compositions/useRequest'

import Skeleton from '@/components/Skeleton/Skeleton'
import AddDialog from './AddDialog/AddDialog'
import GenerateDialog from './GenerateDialog/GenerateDialog'
import Document from '@/components/Document/Document'

export default {
  props: {
    orderId: Number,
  },
  components: {
    AddDialog, Skeleton, Document, GenerateDialog,
  },
  setup(props, context) {
    const { $store } = context.root
    const documents = ref([])

    const { makeRequest, loading } = useRequest({
      context,
      request: () => $store.dispatch('orders/fetchDocuments', { id: props.orderId }),
    })

    const fetch = async () => {
      const response = await makeRequest()
      documents.value = response.documents
    }

    fetch()


    return {
      documents,
      loading,
      fetch,
      cols: '2',
    }
  },
}
